var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, makeObservable } from 'mobx';
import { WordTaskEvaluate } from '../../KnowAWord/WordTask/modules/WordTaskEvaluate';
import { sortByFunc } from '../../../utils/helper/lodash_replacements';
export class MemorizePointsWordTaskEvaluator extends WordTaskEvaluate {
    constructor(parent) {
        super(parent);
        makeObservable(this);
    }
    get wordTask() {
        return this.parent;
    }
    get question() {
        return this.wordTask.question;
    }
    get wordTaskWithWeakestDisprove() {
        if (this.question.memorizePointsRemaining.remainingWordTasks.length === 0)
            return undefined;
        const byDisproves = this.question.memorizePointsRemaining.remainingWordTasks
            .concat()
            .sort(sortByFunc((wordTask) => wordTask.wordTaskNearest.weakestDisprove.inputComparer.overallConflict.disproveCertainty));
        return byDisproves[0];
    }
    get disproveCertainty() {
        if (this.manifestedDisproveCertainty) {
            return this.manifestedDisproveCertainty;
        }
        if (this.question.isOrdered) {
            return super.disproveCertainty;
        }
        if (!this.wordTaskWithWeakestDisprove)
            return 0;
        return this.wordTaskWithWeakestDisprove.wordTaskNearest.weakestDisprove.inputComparer.overallConflict.disproveCertainty;
    }
}
__decorate([
    computed
], MemorizePointsWordTaskEvaluator.prototype, "wordTaskWithWeakestDisprove", null);
